// DeleteCustomer.tsx

import React from "react";
import { Modal, Title, Group, Button } from "@mantine/core";
import classes from "./delete.module.css"; // Make sure to adjust the import path

interface DeleteCustomerProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteCustomer: React.FC<DeleteCustomerProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal opened={isOpen} onClose={onClose}>
      <Title className={classes.title} order={4}>
        Are you sure you want to delete this item?
      </Title>
      <Group className={classes.buttonPart}>
        <Button onClick={onClose} className={classes.buttonCancel}>
          Cancel
        </Button>
        <Button onClick={onConfirm} className={classes.buttonDelete}>
          Delete
        </Button>
      </Group>
    </Modal>
  );
};

export default DeleteCustomer;
